/* Fotoslider op productkaarten, alleen telefoon (Claude) */
(function () {
  if (window.fzFotoslider) return;
  window.fzFotoslider = true;

  var mq = matchMedia('(max-width: 749px)');

  function bouw(kaart) {
    if (kaart.fzsKlaar || kaart.classList.contains('disabled')) return;
    var link = kaart.querySelector('.card-product__media.has-navigation');
    if (!link) return;
    var fotos = Array.prototype.filter.call(link.querySelectorAll(':scope > img'), function (img) {
      if (img.classList.contains('hover-img')) return false;
      if (/js-media-/.test(img.className) && !img.classList.contains('is-visible')) return false;
      return true;
    });
    if (fotos.length < 2) return;
    kaart.fzsKlaar = true;

    var baan = document.createElement('span');
    baan.className = 'fzs-baan swiper-no-swiping';
    fotos.forEach(function (img) { baan.appendChild(img); });
    link.insertBefore(baan, link.firstChild);

    var balk = document.createElement('span');
    balk.className = 'fzs-balk';
    balk.setAttribute('aria-hidden', 'true');
    balk.innerHTML = '<span class="fzs-balk__deel"></span>';
    balk.style.setProperty('--fzs-n', fotos.length);
    link.parentNode.insertBefore(balk, link.nextSibling);
    var deel = balk.firstChild;

    kaart.classList.add('fzs');

    var raf = 0;
    baan.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var w = baan.clientWidth || 1;
        deel.style.transform = 'translateX(' + (baan.scrollLeft / w) * 100 + '%)';
      });
    }, { passive: true });

    /* In de homepage-carrousel: verder vegen bij de eerste of laatste foto schuift de carrousel */
    var startX = 0, opBegin = false, opEind = false;
    baan.addEventListener('touchstart', function (e) {
      startX = e.changedTouches[0].clientX;
      opBegin = baan.scrollLeft <= 2;
      opEind = baan.scrollLeft >= baan.scrollWidth - baan.clientWidth - 2;
    }, { passive: true });
    baan.addEventListener('touchend', function (e) {
      var slider = kaart.closest('card-product-slider');
      if (!slider || !slider.slider) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (opEind && dx < -40) slider.slider.slideNext();
      else if (opBegin && dx > 40) slider.slider.slidePrev();
    }, { passive: true });
  }

  /* Productpagina: dunne balk onder de grote foto, loopt mee met het vegen */
  function pdp() {
    if (!mq.matches) return;
    document.querySelectorAll('product-media .product__media-slider').forEach(function (vak) {
      if (vak.fzsKlaar) return;
      var el = vak.querySelector(':scope > .swiper[data-slider]');
      var pm = vak.closest('product-media');
      var sw = (el && el.swiper) || (pm && pm.settings && pm.settings.sliderInstance);
      if (!sw || !sw.slides) return;
      var n = sw.slides.length;
      if (n < 2) return;
      vak.fzsKlaar = true;

      var balk = document.createElement('span');
      balk.className = 'fzs-balk fzs-balk--pdp';
      balk.setAttribute('aria-hidden', 'true');
      balk.innerHTML = '<span class="fzs-balk__deel"></span>';
      balk.style.setProperty('--fzs-n', n);
      vak.appendChild(balk);
      var deel = balk.firstChild;

      function zet() {
        var p = Math.min(1, Math.max(0, sw.progress || 0));
        deel.style.transform = 'translateX(' + p * (n - 1) * 100 + '%)';
      }
      sw.on('progress', zet);
      sw.on('setTranslate', zet);
      zet();
    });
  }

  function alles(root) {
    if (!mq.matches) return;
    (root || document).querySelectorAll('card-product').forEach(bouw);
  }

  function start() {
    alles();
    pdp();
    [300, 1000, 2500, 5000].forEach(function (t) { setTimeout(pdp, t); });
    window.addEventListener('load', pdp);
    new MutationObserver(function (lijst) {
      if (!mq.matches) return;
      lijst.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.tagName === 'CARD-PRODUCT') bouw(n);
          else if (n.querySelector) alles(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
    mq.addEventListener && mq.addEventListener('change', function () { alles(); pdp(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
